/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { css } from "@emotion/css";
import { fontSize, space, themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
import { TimeSpanHelper } from "../../../utils/TimeSpanHelper";
import type { FormFieldProps } from "../FormFieldProps";
import { DeprecatedNumber } from "../Number";
interface TimeSpanSelectorProps extends FormFieldProps<string> {
    granularity?: string;
    error?: string;
}
export class TimeSpanSelector extends React.Component<TimeSpanSelectorProps, {}> {
    public static DayGranularity: string = "dd";
    public static HourGranularity: string = "hh";
    public static MinuteGranularity: string = "mm";
    public static SecondGranularity: string = "ss";
    public static DayHourMinuteGranularity: string = "dd:hh:mm";
    public static HourMinuteSecondGranularity: string = "hh:mm:ss";
    public static MinuteSecondGranularity: string = "mm:ss";
    getGranularityOrDefault() {
        return this.props.granularity || TimeSpanSelector.DayHourMinuteGranularity;
    }
    render() {
        const { value } = this.props;
        const timeSpan = TimeSpanHelper.getTimeSpanFromText(value);
        const granularity = this.getGranularityOrDefault();
        return (<>
                <div className={styles.container}>
                    {granularity.includes(TimeSpanSelector.DayGranularity) && (<div className={styles.digit}>
                            <DeprecatedNumber label="Days" value={timeSpan!.Days} onChange={this.handleDayChange} min={0}/>
                        </div>)}
                    {granularity.includes(TimeSpanSelector.HourGranularity) && (<div className={styles.digit}>
                            <DeprecatedNumber label="Hours" value={timeSpan!.Hours} onChange={this.handleHourChange} min={0} max={23}/>
                        </div>)}
                    {granularity.includes(TimeSpanSelector.MinuteGranularity) && (<div className={styles.digit}>
                            <DeprecatedNumber label="Minutes" value={timeSpan!.Minutes} onChange={this.handleMinuteChange} min={0} max={59}/>
                        </div>)}
                    {granularity.includes(TimeSpanSelector.SecondGranularity) && (<div className={styles.digit}>
                            <DeprecatedNumber label="Seconds" value={timeSpan!.Seconds} onChange={this.handleSecondChange} min={0} max={59}/>
                        </div>)}
                </div>
                {this.props.error && <div className={styles.error}>{this.props.error}</div>}
            </>);
    }
    private notifyChange(value: string) {
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }
    private handleDayChange = (value: number | undefined) => {
        const timeSpan = TimeSpanHelper.getTimeSpanFromText(this.props.value);
        timeSpan!.Days = value ?? 0;
        const returnVal = TimeSpanHelper.getDotNetFormattedTimeSpanTextFromTimeSpan(timeSpan);
        this.notifyChange(returnVal);
    };
    private handleHourChange = (value: number | undefined) => {
        const timeSpan = TimeSpanHelper.getTimeSpanFromText(this.props.value);
        timeSpan!.Hours = value ?? 0;
        const returnVal = TimeSpanHelper.getDotNetFormattedTimeSpanTextFromTimeSpan(timeSpan);
        this.notifyChange(returnVal);
    };
    private handleMinuteChange = (value: number | undefined) => {
        const timeSpan = TimeSpanHelper.getTimeSpanFromText(this.props.value);
        timeSpan!.Minutes = value ?? 0;
        const returnVal = TimeSpanHelper.getDotNetFormattedTimeSpanTextFromTimeSpan(timeSpan);
        this.notifyChange(returnVal);
    };
    private handleSecondChange = (value: number | undefined) => {
        const timeSpan = TimeSpanHelper.getTimeSpanFromText(this.props.value);
        timeSpan!.Seconds = value ?? 0;
        const returnVal = TimeSpanHelper.getDotNetFormattedTimeSpanTextFromTimeSpan(timeSpan);
        this.notifyChange(returnVal);
    };
    static displayName = "TimeSpanSelector";
}
const styles = {
    container: css({
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
    }),
    separator: css({
        margin: `0 ${space[64]} 0 ${space[2]}`,
        color: themeTokens.color.textField.text.primary,
    }),
    error: css({
        color: themeTokens.color.textField.text.danger,
        fontSize: fontSize.xSmall,
        marginTop: space[2],
    }),
    digit: css({
        width: space[48],
        marginRight: space[12],
    }),
};
